export function createSceneSlot() {
    let owner;
    let content = null;
    const listeners = new Set();
    const emit = () => listeners.forEach((listener) => listener());
    return {
        get: () => content,
        active: () => owner !== undefined,
        owner: () => owner,
        set(next, nextContent) {
            owner = next;
            content = nextContent;
            emit();
        },
        clear(previous) {
            if (owner !== previous)
                return;
            owner = undefined;
            content = null;
            emit();
        },
        subscribe(listener) {
            listeners.add(listener);
            return () => { listeners.delete(listener); };
        },
    };
}
